import React from 'react';
import posed from 'react-pose';
import styles from './index.module.less';

const Bg = posed.div({
  exit: {
    width: '0',
  },
  enter: {
    width: '100%',
    delay: 300,
    transition: {
      duration: 800,
      ease: [0.87, 0.02, 0.17, 1],
    },
  },
});

const Background = () => (
  <Bg
    className={styles.main}
    initialPose="exit"
    pose="enter"
  />
);

export default Background;
